<sgt-pedido-pedido-list
    #list
    tableId="resultadoCampanhaTablePedidosNaoLiberados"
    visualizacaoStorageKey="resultadoCampanhaVendaListPedidosNaoLiberados"
    [filter]="pedidoFilter"
    (afterLiberarPedido)="afterLiberarPedido.emit()"
    (afterCancelar)="afterLiberarPedido.emit()"
    [optionsVisibility]="{
        canEdit: false,
        canConsultar: false,
        canConfirmar: false,
        canExportOneErp: false,
        canEnviarEmail: false,
        canPrint: true,
        canDuplicate: false,
        canLiberar: true,
        canIniciarAguardandoProducao: false,
        canTerminarAguardandoProducao: false,
        canLiberarExpedicao: false,
        canCancelar: true,
        canImportOneEcommerce: false,
        canImportOneErp_v1: false,
        canImportOneErp: false,
        canOpenRetornoAmostras: false,
        canSolicitarRevisao: false,
        canRevisar: false,
        canConfirmarPCP: false,
        canPrintPropostaComercial: false,
        canSendEmailPropostaComercial: false,
        canRetornarAnaliseCliente: false        
    }"
    [columnsVisibility]="{
        options: true,
        badges: false,
        lucroLiquido: true,
        numero: true,
        numeroEcommerce: false,
        numeroERP: false,
        dataEmissao: true,
        dataConfirmacao: true,
        quantidadeTotal: true,
        quantidadeVolumesPrevistos: true,
        valorTotal: true,
        status: true,
        setorGep: false,
        cliente: true,
        classificacaoFaturamentoPretendida: true,
        representante: true,
        motivoReprovado: false,
        tabelaPreco: true,
        campanha: false,
        condicaoPagamento: true,
        motivoNaoLiberado: true,
        dataNaoLiberado: true,
        vendaReferenciada: true,
        lucroLiquidoNaoLiberado: true,
        dataLiberado: false,
        usuarioLiberado: false,
        justificativaLiberado: false
    }">
</sgt-pedido-pedido-list> 